<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    fill="#FFF370"
    d="M7.982 7.179h8.036v4.017H7.982V7.18Z"
  /><path
    fill="#B7DFF0"
    d="M16.018 7.179a4.018 4.018 0 0 0-8.036 0h8.036ZM7.982 11.197h8.036l1.607 11.25H6.375l1.607-11.25Z"
  /><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    d="M7.982 11.197h8.036l1.607 11.25H6.375l1.607-11.25ZM12 22.446v-2.41M7.982 7.179a4.018 4.018 0 1 1 8.036 0v4.017H7.982V7.18ZM6.777 7.179h10.446M6.777 11.197h10.446M12 3.16V1.555M2.357 6.375l1.607.804M2.357 12l1.607-.803M21.643 6.375l-1.607.804M21.643 12l-1.607-.803"
  /></svg>
</template>
